import PaymentStatusCard from "../../../Components/PaymentStatusCard";

const PaymentFailed = () => <PaymentStatusCard status="failed" />;

export default PaymentFailed;
